import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopNavbar from "../top-navbar/TopNav"; 
import {
  FaFileInvoiceDollar,
  FaFileAlt,
  FaIdCard,
  FaBriefcase,
    FaCamera,
} from "react-icons/fa";
import "../../styles/employee/ai-modules.css";


const AIModules = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const modules = [
    {
      title: "Bank Statement Parser",
      description:
        "Extract and analyze salary credits from uploaded bank statements using AI-powered OCR and pattern recognition.",
      icon: <FaFileInvoiceDollar />,
      path: "/employee/aiModules/bank-statement",
    },
    {
      title: "Utility Bill Analyzer",
      description:
        "Auto-read addresses and customer details from electricity or water bills using smart parsing.",
      icon: <FaFileAlt />,
      path: "/employee/aiModules/utility-bill", 
    },
    {
      title: "Resume Parser ",
      description:
        "Automatically extract education, experience, and skills from resumes using AI-powered parsing.",
      icon: <FaIdCard />,
        path: "/employee/aiModules/resume-parser",
    },
{
      title: "Document Forgery Detection",
      description:
        "Detect forged or tampered documents using AI-powered analysis and pattern recognition.",
      icon: <FaBriefcase />,
      path: "/employee/aiModules/document-forgery",
    },
    {
      title: "Face Matching AI",
      description:
        "Verify if a person’s selfie matches the Aadhaar ID photo using advanced facial recognition.",
      icon: <FaCamera />,
      path: "/employee/aiModules/face-matching",
    },
  ];

  return (
    <div className="emp-aimodules-dashboard-app-container">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Panel */}
      <div className="emp-aimodules-dashboard-right-panel">
        <TopNavbar />

        <div className="emp-aimodules-info-container">
          <div className="emp-aimodules-info-header">
            <h2>AI Modules</h2>
            <p>
              Explore intelligent automation modules designed to simplify document verification and
              data extraction.
            </p>
          </div>

          <div className="emp-aimodules-grid">
            {modules.map((module, index) => (
              <div className="emp-aimodules-card" key={index}>
                <div className="emp-aimodules-icon">{module.icon}</div>
                <h3>{module.title}</h3>
                <p>{module.description}</p>
                {module.path ? (
                  <button
                    className="emp-aimodules-btn"
                    onClick={() => handleNavigate(module.path)}
                  >
                    Open Module
                  </button>
                ) : (
                <button className="emp-aimodules-btn" disabled>
                    Coming Soon
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIModules;
